/*! @azure/msal-common v14.14.2 2024-09-03 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "14.14.2";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
